.kdx-pagination {
    text-align: center;

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        text-align: center;

        li {
            display: inline-block;
            padding: 0;
            margin: 0 8px;

            a {
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #FFF;
                border: 1px solid #DEDEDE;
                min-height: 50px;
                min-width: 50px;
                border-radius: 3px;
                text-decoration: none;
                font-weight: 700;
                box-shadow: none;           
                @include text-size(20);
                @include transitionDefault(all);

                svg {
                    @include svg-format(15px, 15px, $primary);
                    @include transitionDefault(fill);
                }

                &[disabled] {
                    pointer-events: none;
                    background-color: #DEDEDE;

                    svg {
                        fill: #FFF;
                    }
                }

                &.active {
                    pointer-events: none;
                    background-color: $pagingActive;
                    color: $pagingActiveText;
                }

                &:not(.active):hover, &:not(.active):focus {                    
                    background-color: $pagingHover;
                    color: $pagingHoverText;
                    @include transitionDefault(all);

                    svg {
                        fill: #FFF;
                        @include transitionDefault(fill);
                    }
                }
            }

            &:before {
                display: none;
            }

            &:first-child {
                margin: 0 8px 0 0;
            }

            &:last-child {
                margin: 0 0 0 8px;
            }
        }
    }
    .paging-status {
        font-style: italic;
        margin-top: 24px;
        color: #3B3B3B;
    }
}



@include media-breakpoint-down(md) {
    .kdx-pagination {
        
        ul {
            li {
                margin: 0 2px;

                a {
                    min-width: 30px;
                    min-height: 30px;
                    @include text-size(12);
                    @include line-height(17);
                }
            }
        }
        .paging-status {
            @include text-size(10);
            @include line-height(24);
            margin-top: 16px;
        }
    }
}